jQuery(document).ready(function ($) {
	$(".input-field input, .input-field textarea").on("keyup", (e) => {
		const field = $(e.target).parent().parent().siblings("label");

		updateFieldLabelPosition(field, e.target);
	});

	$("video").on("click keypress", (e) => {
		if (e.type == "click" || e.key == "Enter") {
			togglePlayVideo($(e.target));
		}
	});

	$(".playpause").on("click", (e) => {
		const playButtonClicked = $(e.target);
		const video = $(playButtonClicked.siblings("video"));

		togglePlayVideo(video);
	});

	if ($(".parallax-image").length) {
		gsap.to(".parallax-image img", {
			scrollTrigger: {
				scrub: true,
			},
			y: (i) => -ScrollTrigger.maxScroll(window) * 0.05,
			ease: "none",
		});
	}
});
